export const ROLES = {"admin": "Администратор", "moderator": "Модератор", "user": "Пользователь"};
